import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clientType',
})
export class ClientTypePipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (value) {
      return 'Company';
    }
    return 'Individual';
  }
}
